import { formatResistanceReduction } from '../../../shared/rules/effects/resistanceDamage.mjs';
import React from 'react';
import './SpellSaveResults.scss';
export default function SpellSaveResults({ feedback, targetName = id => id }) {
  if (!feedback) return null;
  return <ul className="spell-save-results" aria-label="Spell saving throw results">
    {feedback.targets.map(target => <li key={target.id} className={target.status === 'resolved' ? target.success ? 'text-success' : 'text-danger' : ''}>
      <strong>{target.targetName || targetName(target.targetCombatantId)}</strong>: {target.status === 'resolved'
        ? `${target.success ? 'Save succeeded' : 'Save failed'} · ${target.finalDamage} ${feedback.damageType || 'spell'} damage`
        : target.status === 'cancelled' ? 'Cancelled' : target.status === 'waiting-damage' ? 'Waiting for damage roll' : 'Waiting for saving throw…'}
      {target.resistanceReduction && <small className="d-block">{formatResistanceReduction(target.resistanceReduction)}</small>}
    </li>)}
  </ul>;
}
